import { useSyncExternalStore } from 'react';
import { useMatches } from 'react-router-dom';
import { getCrumbsSnapshot, subscribeCrumbs } from '@shared/shell/crumbStore';
import { useActiveSuite } from '../useActiveSuite';
import { buildCrumbs, Crumb } from './buildCrumbs';

export function useCrumbs(): Crumb[] {
  const matches = useMatches();
  const activeSuite = useActiveSuite();
  const overrides = useSyncExternalStore(subscribeCrumbs, getCrumbsSnapshot, getCrumbsSnapshot);

  return buildCrumbs(matches, activeSuite, overrides);
}
